import { LitElement, css, html } from 'lit';
import { customElement, state, query } from 'lit/decorators.js';
import getUrl from '../utils/getUrl';

@customElement('ls-drawer')
export class LsDrawer extends LitElement {
    static styles = css`
        .ls-drawer {
            display: flex;
            align-items: center;
        }

        .drawer-icon {
            cursor: pointer;
        }

        .cancel-icon {
            cursor: pointer;
            position: absolute;
            top: 20px;
            right: 20px;
        }

        .drawer-background {
            top: 0;
            left: 0;
            opacity: 0;
            width: 100%;
            height: 100%;
            background-color: #00000099;
            transition: opacity 0.3s ease;
        }

        .drawer-background.active {
            position: fixed;
            opacity: 1;
        }

        .drawer-content {
            box-sizing: border-box;
            position: absolute;
            top: 0;
            left: 0;
            width: 360px;
            height: 100%;
            background-color: #fff;
            padding: 32px 20px;

            @media (max-width: 576px) {
                width: 100%;
            }
        }
    `;

    @state() isDrawerOpen: boolean = false;

    @query('.drawer-background') drawerBackground!: HTMLElement;

    private _handleDrawerIconClick() {
        this.isDrawerOpen = !this.isDrawerOpen;
        this.drawerBackground.style.zIndex = '1000';
    }

    private _handleCancelIconClick() {
        this.isDrawerOpen = false;
        setTimeout(() => (this.drawerBackground.style.zIndex = '-1000'), 300);
    }

    private _handleDrawerBackgroundClick(e: Event) {
        if (e.target === this.drawerBackground) this._handleCancelIconClick();
    }

    protected render() {
        const drawerIconUrl = getUrl(`assets/images/drawer-icon.webp`);
        const cancelIconUrl = getUrl(`assets/images/cancel-icon.webp`);
        return html` <div class="ls-drawer">
            <img
                src=${drawerIconUrl}
                alt="drawer-icon"
                width="22"
                class="drawer-icon"
                @click=${this._handleDrawerIconClick}
            />

            <section
                class="drawer-background ${this.isDrawerOpen && 'active'}"
                style="z-index: -10;"
                @click=${(e: Event) => this._handleDrawerBackgroundClick(e)}
            >
                <div class="drawer-content">
                    <img
                        src=${cancelIconUrl}
                        alt="cancel-icon"
                        width="16"
                        class="cancel-icon"
                        @click=${this._handleCancelIconClick}
                    />
                    <slot></slot>
                </div>
            </section>
        </div>`;
    }
}
